"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/05
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const logging_1 = tslib_1.__importDefault(require("./namespaces/logging"));
function applyLogging(fn) {
    return (...args) => {
        const loggingEnabled = logging_1.default.getStatus();
        if (loggingEnabled) {
            fn(`[@8x8/pui-partner-comm]`, ...args);
        }
    };
}
const logger = {
    log: applyLogging(console.log),
    error: applyLogging(console.error),
    warn: applyLogging(console.warn),
};
exports.default = logger;
//# sourceMappingURL=logger.js.map